/* eslint-disable import/extensions */
import properties from './properties.js';
import { getCustomPalette, getThemePaletteName, hasThemePaletteBeenMutated } from './utils.js';

const query = (host, prop) => {
	if (properties.indexOf(prop) < 0) return {};
	let value = host.getProperty(prop);

	const dossierFontFamily = host.controller.model.defmts[1].props.FormattingFont.Name;

	switch (prop) {
		case 'fontFamilyTotal':
			if (
				dossierFontFamily &&
				host.getProperty('dossierFontFamilyTotal') !== dossierFontFamily
			) {
				return { value: dossierFontFamily };
			}
			return { value };
		case 'fontFamilyName':
			if (
				dossierFontFamily &&
				host.getProperty('dossierFontFamilyName') !== dossierFontFamily
			) {
				return { value: dossierFontFamily };
			}
			return { value };
		case 'fontFamilyLevelName':
			if (
				dossierFontFamily &&
				host.getProperty('dossierFontFamilyLevelName') !== dossierFontFamily
			) {
				return { value: dossierFontFamily };
			}
			return { value };
		case 'fontFamilyGlobal':
			if (
				dossierFontFamily &&
				host.getProperty('dossierFontFamilyGlobal') !== dossierFontFamily
			) {
				return { value: dossierFontFamily };
			}
			return { value };
		case 'groupedNodeColor':
			if (host.getProperty('radioForNodeColorPalettes') !== 'groupedNodes') {
				return { value, visible: false };
			}
			return {
				value,
				visible: true
			};
		case 'overlapWarning':
			if (
				(host.getProperty('minorValuesGroupFrom') <
					host.getProperty('minorValuesHideThreshold') ||
					host.getProperty('minorValuesGroupTo') <
						host.getProperty('minorValuesHideThreshold')) &&
				host.getProperty('minorValuesIsGroupEnabled') &&
				host.getProperty('minorValuesIsHidingEnabled')
			) {
				return { visible: true };
			}
			return { visible: false };
		case 'dataLabelsHideableLayout':
			return {
				value: { isDisabled: !JSON.parse(host.getProperty('showName')) }
			};
		case 'totalHideableLayout':
			return {
				value: { isDisabled: !JSON.parse(host.getProperty('showTotal')) }
			};
		case 'flowFillColor':
			if (host.getProperty('flowFillType') !== 'solid') {
				return { value, enable: false };
			}
			return {
				value,
				enable: true
			};
		case 'totalAlignment':
			if (!JSON.parse(host.getProperty('showTotalOnLabel'))) {
				return { value, enable: false };
			}
			return {
				value,
				enable: true
			};
		case 'density':
			if (host.getProperty('densityMode') === 'auto') {
				return { value: host.defaultDensity };
			}
			return { value };
		case 'nodeColorPaletteContainer':
			if (host.getProperty('radioForNodeColorPalettes') !== 'nodes') {
				return { visible: false };
			}
			return { visible: true };

		case 'nodeColorPalette':
			return { value: getCustomPalette(value, host), visible: true };

		case 'nodeColorPaletteTitle': {
			const themePaletteName = getThemePaletteName();
			const themePaletteTitle = `${themePaletteName} Palette`;
			const customPalette = host.getProperty('nodeColorPalette');
			const newValue =
				hasThemePaletteBeenMutated(customPalette) || !themePaletteName
					? 'Custom Palette'
					: themePaletteTitle;
			return {
				value: newValue
			};
		}
		case 'isVerticalScrollEnabled':
			if (value) {
				document.querySelector('.sankey').style['overflow-y'] = 'scroll';
			}
			return { value };
		case 'userPalette': {
			const dossierCustomColors = mstrmojo.util.ui.ColorPicker.getCustomColors();
			const userPalette = value && value.split(',');
			if (value && dossierCustomColors.length === 0) {
				userPalette.forEach((color) => mstrmojo.util.ui.ColorPicker.addCustomColor(color));
			}
			return { value: userPalette?.join() };
		}
		case 'resetCachedNodes':
			if (JSON.parse(host.getProperty('isDraggingOfNodesEnabled'))) {
				return { enable: true };
			}
			return { enable: false };
		default:
			try {
				value = JSON.parse(value);
				// eslint-disable-next-line no-empty
			} catch (error) {}

			return {
				value,
				enable: true,
				visible: true
			};
	}
};

export default query;
